/**
 * DeltaChip — tiny trend indicator vs the previous period
 * (2026-07-26 design audit item 4).
 *
 * mode 'pct': relative change, curr vs prev counts → "▲ 23%"
 * mode 'pts': absolute percentage-point change     → "▲ 6pt"
 *
 * Renders nothing when prev is null/undefined (period='all'), when
 * prev is 0 in pct mode (no "▲∞%"), or when the change rounds to 0 —
 * a chip that says nothing is noise.
 */
export default function DeltaChip({ curr, prev, mode = 'pct' }) {
  if (prev == null) return null;
  let delta;
  let label;
  if (mode === 'pts') {
    delta = Math.round((curr || 0) - prev);
    label = `${Math.abs(delta)}pt`;
  } else {
    if (prev === 0) return null;
    delta = Math.round((((curr || 0) - prev) / prev) * 100);
    label = `${Math.abs(delta)}%`;
  }
  if (delta === 0) return null;
  const up = delta > 0;
  return (
    <span
      title={`vs previous period: ${prev}${mode === 'pts' ? '%' : ''}`}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 2,
        marginLeft: 6,
        padding: '1px 6px',
        borderRadius: 100,
        fontSize: 10,
        fontWeight: 700,
        letterSpacing: '0.02em',
        background: up ? 'rgba(16, 185, 129, 0.13)' : 'rgba(239, 68, 68, 0.11)',
        color: up ? '#047857' : '#dc2626',
        whiteSpace: 'nowrap',
      }}
    >
      {up ? '▲' : '▼'} {label}
    </span>
  );
}
